
import { SimulationConfig, EscapeRing } from '../types';

export class EscapeService {
  public static generateRings(config: SimulationConfig): EscapeRing[] {
    const rings: EscapeRing[] = [];
    const baseAngle = (config.escapeFixedGapDirection * Math.PI / 180);
    const oppositeGapSize = (config.escapeOppositeGapSize || 30);
    const oppositeCount = (config.escapeOppositeGapCount || 0);

    for (let i = 0; i < config.escapeRingCount; i++) {
        let angle = baseAngle;
        let isOpposite = i < oppositeCount;
        
        // Base Alignment Logic
        if (config.escapeGapAlignment === 'RANDOM') {
            angle = Math.random() * Math.PI * 2;
            // Opposite logic doesn't apply well to random, but we can flip it if requested
            if (isOpposite) angle = (angle + Math.PI) % (Math.PI * 2);
        }
        else if (config.escapeGapAlignment === 'SPIRAL') {
            angle = baseAngle + i * (config.escapeSpiralTightness || 0.15);
            if (isOpposite) angle += Math.PI;
        }
        else if (config.escapeGapAlignment === 'STAGGERED') {
            angle = baseAngle + (i % 2 === 0 ? 0 : Math.PI);
            // Opposite overrides staggered? Or flips it? Let's flip it.
            if (isOpposite) angle += Math.PI;
        }
        else {
            // ALIGNED, ONE_SIDE, FIXED_SIZE
            if (isOpposite) {
                angle = baseAngle + Math.PI;
            }
        }

        // Store custom gap data in the ID or object if needed, 
        // but currently gap size is calculated during collision.
        // We will misuse the 'hue' or add a property if we could, 
        // but 'EscapeRing' type is strict. 
        // Workaround: We don't have per-ring gap size in types yet.
        // Wait, the collision logic in App.tsx calculates gap width based on config.
        // We need to support per-ring gap size in App.tsx logic.
        // For now, let's keep the ring generation standard.
        // The App.tsx logic needs to know if this ring is "opposite" to apply "oppositeGapSize".
        // Since we can't change types easily without breaking other things, let's just 
        // encode the fact that it is "Opposite" by checking the index in the collision loop in App.tsx?
        // Actually, App.tsx has the rings array. It can check index vs config.
        
        const baseRadiusForRings = config.mode === 'RHYTHMIC_ESCAPE' ? (config.rhythmicEscapeShieldRingRadius || 100) : config.containerRadius;
        
        rings.push({
            id: `ring-${i}-${Math.random()}`,
            radius: baseRadiusForRings + (i + 1) * config.escapeRingSpacing,
            angle: angle, 
            hue: (i * (360 / Math.max(config.escapeRingCount, 1))) % 360
        });
    }
    return rings;
  }
}
